<ng-container *ngIf="data.component === 'Verification Package'">
    <div class="py-2 px-3">
        <h1 mat-dialog-title>{{ deactivate ? 'Deactivate' : 'Activate' }} Verification Package</h1>
        <div mat-dialog-content>
            <p>Are you sure you want to {{ deactivate ? 'deactivate' : 'activate' }} this Verification Package?</p>
        </div>
        <div class="mt-4 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <ng-container *ngIf="!deactivate">
                <button mat-raised-button class="action-button" (click)="onConfirmClick()">
                    <mat-icon>add</mat-icon>
                    Activate
                </button>
            </ng-container>
            <ng-container *ngIf="deactivate">
                <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
                    <mat-icon>delete</mat-icon>
                    Deactivate
                </button>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="data.component === 'Organization'">
    <div class="py-2 px-3">
        <h1 mat-dialog-title>{{ deactivate ? 'Deactivate' : 'Activate' }} Organization</h1>
        <div mat-dialog-content>
            <p>Are you sure you want to {{ deactivate ? 'deactivate' : 'activate' }} this Organization?</p>
        </div>
        <div class="mt-4 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <ng-container *ngIf="!deactivate">
                <button mat-raised-button class="action-button" (click)="onConfirmClick()">
                    <mat-icon>add</mat-icon>
                    Activate
                </button>
            </ng-container>
            <ng-container *ngIf="deactivate">
                <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
                    <mat-icon>delete</mat-icon>
                    Deactivate
                </button>
            </ng-container>
        </div>
    </div>
</ng-container>